// import { generatePermissionsAll } from 'helpers/verifyPermission';

export const menuPermissions = [
    { path: "/", icon: "home", label: "Início", permissions: [] },
    { path: "/meus-mapas", icon: "mapas", label: "Meus mapas", permissions: [] },
    // { path: "/usuarios/gerenciar", icon: "asterisk", label: "Meus mapas", permissions: [] },
]